import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";

export interface MST3010_R01Dto extends WorkPlaceDto {

	inWarehouseNm: string;
	outWarehouseNm: string;
	badWarehouseNm: string;
	workEmpNm: string;

}



// 기본 작업장 데이터
export const defaultMST3010_R01Dto: MST3010_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	workplaceCd: '',
	workplaceNm: '',
	compCd: '',
	compNm: '',
	displaySeq: 0,
	workProcess: '',
	useYn: 'Y',
	orderYn: 'Y',
	barcodePrint: 'Y',
	levelCd: '',
	outsourcingYn: 'Y',
	scanHistory: 'Y',
	faultyYn: 'Y',
	logicCenter: '',
	inWarehouse: '',
	outWarehouse: '',
	badWarehouse: '',
	workEmpNo: '',
	remark: '',

	inWarehouseNm: '',
	outWarehouseNm: '',
	badWarehouseNm: '',
	workEmpNm: '',

	inserted: false,
	isModified: false,

	insertDt: new Date(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date(),
	updateUser: '',
	updateForm: ''
};